import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'src/components/ui/card';
import { Badge } from 'src/components/ui/badge';
import { Button } from 'src/components/ui/button';
import { RefreshCw, Coins } from 'lucide-react';

interface TokenHoldingsOverviewEmptyProps {
  onRetry: () => void;
  isRetrying: boolean;
}

export const TokenHoldingsOverviewEmpty = ({
  onRetry,
  isRetrying,
}: TokenHoldingsOverviewEmptyProps) => {
  return (
    <Card className="mx-auto w-full max-w-[1500px] rounded-lg border border-muted-50 bg-background bg-white shadow-[0_0_10px_rgba(0,0,0,0.1)] dark:border-muted-200">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium uppercase text-muted-foreground">
            Token Holdings
          </CardTitle>
          <Badge variant="outline">0 Token Contracts</Badge>
        </div>
      </CardHeader>

      <CardContent>
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <Coins className="mb-4 h-12 w-12 text-muted-foreground" />
          <h3 className="mb-2 text-lg font-semibold text-foreground">
            No Token Holdings Found
          </h3>
          <p className="mb-6 max-w-md text-muted-foreground">
            This address doesn&apos;t hold any ERC-20 tokens, or the tokens
            haven&apos;t been indexed yet. Token balances are updated regularly
            as new transactions occur.
          </p>
          <Button
            onClick={onRetry}
            disabled={isRetrying}
            variant="outline"
            size="sm"
          >
            {isRetrying ? (
              <>
                <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
                Checking...
              </>
            ) : (
              <>
                <RefreshCw className="mr-2 h-4 w-4" />
                Check Again
              </>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
